import ResimdoIcon from "./ResimdoIcon";
export * from "./ResimdoIcon";

export default ResimdoIcon;
